import { NgModule } from '@angular/core';
import { RxRoatingArrowComponent } from './rx-roating-arrow.component';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [CommonModule, RxRoatingArrowComponent],
  exports: [RxRoatingArrowComponent],
})
export class RxRoatingArrowModule {}
